export const DEFAULT_LABELS = {
	brandYoutube: 'YouTube',
	brandInstagram: 'Instagram',
	brandTiktok: 'TikTok',
	brandTwitter: 'X (formerly Twitter)',
	brandFacebook: 'Facebook',
	brandLinkedin: 'LinkedIn'
};
